import { createTranslationService } from '@services/factories';
import { StringFormatService } from '@services/StringFormatService';
import { IPinCodeStore } from '@stores/authorisation/pin-code-store';
import { observer } from 'mobx-react';
import * as React from 'react';
import { cacheTranslations } from '@utils/cache-translations';
import {
    Label,
    SendCodeMessage,
    TickIcon
} from './resend-code-label-styles';
import { ErrorLabel } from '@screens/review-section3/pincode-authorisation/pin-code-form-styles';
import { SendPinCodeResult } from '@models/send-pin-code-result';

export enum ResendCodeLabelTranslation {
    pinCodeRequestError = 'pinCodeRequestError',
    initialPinCodeSent = 'initialPinCodeSent',
    resentPinCode = 'resentPinCode'
}

interface Props {
    store: IPinCodeStore;
    candidateFullName: string;
}

enum ApplicationStatus {
    applicationApproved = 'applicationApproved',
    applicationDeclined = 'applicationDeclined'
}

class ResendCodeLabel extends React.Component<Props> {
    static translationsContext: string = 'resendCodeLabel';

    translations = cacheTranslations(
        createTranslationService(),
        ResendCodeLabelTranslation,
        ResendCodeLabel.translationsContext
    );

    applicationStatusTranslations = cacheTranslations(createTranslationService(), ApplicationStatus);

    renderLabel = (label: string, additionalContent?: React.ReactNode) => {
        return (
            <Label>
                <SendCodeMessage>{label}</SendCodeMessage>
                { additionalContent }
            </Label>
        );
    };

    render() {
        const getLabel = (resourceKey: ResendCodeLabelTranslation): string => {
            const translations = this.translations;

            return StringFormatService.format(
                translations[resourceKey],
                [this.props.candidateFullName]
            );
        };

        const {
            pinCodeResponses,
            hadErrorSendingPinCode,
            pinCodeResult
        } = this.props.store;

        if (hadErrorSendingPinCode) {
            return this.renderLabel(getLabel(ResendCodeLabelTranslation.pinCodeRequestError));
        }

        if (pinCodeResponses < 1) {
            return null;
        }

        if (pinCodeResult === SendPinCodeResult.ApplicationApproved) {
            return <ErrorLabel>{this.applicationStatusTranslations.applicationApproved}</ErrorLabel>;
        }

        if (pinCodeResult === SendPinCodeResult.ApplicationDeclined) {
            return <ErrorLabel>{this.applicationStatusTranslations.applicationDeclined}</ErrorLabel>;
        }

        if (pinCodeResponses === 1) {
            return this.renderLabel(
                getLabel(ResendCodeLabelTranslation.initialPinCodeSent),
                <TickIcon/>
            );
        }

        return this.renderLabel(
            getLabel(ResendCodeLabelTranslation.resentPinCode),
            <TickIcon/>
        );
    }
}

export default observer(ResendCodeLabel);



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/resend-code-label.tsx